module.exports = __webpack_public_path__ + "img/seminar (8).8a6569f5.jpg";